export const AdjustInitializationGuards = {
  canTrack: () => false,
};
